import React, { Component } from 'react';
import { Formik } from 'formik';

import { Button, Col, Form, FormFeedback, FormGroup, Label, Input, Row, Card, CardBody, CardHeader } from 'reactstrap';
import * as Yup from 'yup';
import { Helmet } from 'react-helmet'
import Postman from '../../utils/service'
import './index.css'
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
const ValidationSchema = Yup.object().shape({
  full_name: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  phone: Yup.string()
    .matches(phoneRegExp, 'Phone number is not valid'),
  email: Yup.string()
    .email('Invalid email')
    .required('Required'),
  message: Yup.string()
    .min(2, 'Too Short!')
    .required('Required'),
});

class ScheduleDemo extends Component {

  onSubmit = (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
    Postman.contactmsg(values)
      .then(res => {
        if (res.status == 200) resetForm()
      })
  }

  render() {
    return (
      <div className="animated fadeIn mainView" style={{ height: '100%' }}>
        <Helmet>
          <title>Growjo - Schedule Demo</title>
          <meta name="description" content="Growjo: Schedule Demo" />
          <meta name="author" content="Growjo"></meta>
        </Helmet>
        <Card style={{ height: '100%' }}>
          <CardHeader className='cardHeader'>
            <div className='text-center'><h1 style={{ color: '#474866', fontSize: 45, marginBottom: 0 }}>License the Growjo Company Data API</h1></div>
            <div className='text-center'><i>Tracking the inner workings and growth rates of the hottest startups</i></div>
          </CardHeader>
          <CardBody>
            <Row>
              <Col sm={4} className='offset-2'>
                <div className='sd-left-text row'>
                  <div className='col-md-2'>
                    <img className='sd-svg-img' src="/static/schedule-demo-1.svg" />
                  </div>
                  <div className='col-md-10' style={{ paddingLeft: '25px' }}>
                    <span className='sd-blue-text'>
                      Startup Intelligence
                    </span>
                    &nbsp;- We track the employee size growth rates, funding events, new location data, job opening growth of the 2M fastest growing companies!
                  </div>

                </div>
                <div className='sd-left-text row'>
                  <div className='col-md-2'>
                    <img className='sd-svg-img' src="/static/schedule-demo-2.svg" />
                  </div>
                  <div className='col-md-10' style={{ paddingLeft: '25px' }}>
                    <span className='sd-blue-text'>
                      Growth Rates Updated Every Other Month
                    </span>
                    &nbsp;- The best way to stay on top of fast growing companies is by looking at their 1 year employee growth. Our data is updated every other month
                  </div>

                </div>
                <div className='sd-left-text row'>
                  <div className='col-md-2'>
                    <img className='sd-svg-img' src="/static/schedule-demo-3.svg" />
                  </div>
                  <div className='col-md-10' style={{ paddingLeft: '25px' }}>
                    <span className='sd-blue-text'>
                    Revenue Data
                    </span>
                    &nbsp;- Get access to our revenue dataset coming from company submissions, blog posts, public data and our own algorithm.
                  </div>

                </div>
                <div className='sd-left-text row'>
                  <div className='col-md-2'>
                    <img className='sd-svg-img' src="/static/schedule-demo-3.svg" />
                  </div>
                  <div className='col-md-10' style={{ paddingLeft: '25px' }}>
                    <span className='sd-blue-text'>
                      CSV Bulk Exports & Unlimited API Calls
                    </span>
                    &nbsp;- Get access to our unique growth ranking algorithm and our updates every other month using our unlimited api calls or bulk csv exports.
                  </div>

                </div>
                <div className='sd-left-text row'>
                  <div className='col-md-2'>
                  <i className='fa fa-volume-control-phone' style={{  fontSize: 40, color: 'rgb(79, 130, 175)' }}></i>

                    {/* <img className='sd-svg-img' src="/static/schedule-demo-3.svg" /> */}
                  </div>
                  <div className='col-md-10' style={{ paddingLeft: '25px' }}>
                    <span className='sd-blue-text'>
                    400M Contacts with Emails, Phone, etc
                    </span>
                    &nbsp;- 
                    Growjo has licensed the Lead411 <a href="https://www.lead411.com" target="_blank">sales lead database</a> for added intelligence, verified email addresses and b2b direct dials.
                  </div>

                </div>

              </Col>
              <Col sm={4} className='sd-contact-div '>
                <img src="/static/growjo-logo.png" alt="logo" width="100%" />
                <div className='sd-blue-text' ><p>Talk with us today.</p></div>
                <Formik
                  initialValues={{
                    full_name: '',
                    phone: '',
                    email: '',
                    message: '',
                  }}
                  validationSchema={ValidationSchema}
                  onSubmit={this.onSubmit}
                >
                  {({ errors, touched, values, handleChange, handleSubmit, isValid, setTouched }) => (
                    <Form onSubmit={handleSubmit} noValidate name='subscribeForm' style={{ width: "100%" }}>
                      <FormGroup >
                        <Label>Full Name<span className="text-danger"> *</span></Label>
                        <Input type="text"
                          name="full_name"
                          id="full_name"
                          placeholder=""
                          valid={!errors.full_name && values.full_name != ''}
                          invalid={touched.full_name && !!errors.full_name}
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          value={values.full_name} />
                        <FormFeedback>{errors.full_name}</FormFeedback>
                      </FormGroup>
                      <FormGroup >
                        <Label>Email<span className="text-danger"> *</span></Label>
                        <Input type="text"
                          name="email"
                          id="email"
                          placeholder=""
                          valid={!errors.email && values.email != ''}
                          invalid={touched.email && !!errors.email}
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          value={values.email} />
                        <FormFeedback>{errors.email}</FormFeedback>
                      </FormGroup>
                      <FormGroup >
                        <Label>Phone Number</Label>
                        <Input type="text"
                          name="phone"
                          id="phone"
                          placeholder=""
                          valid={!errors.phone && values.phone != ''}
                          invalid={touched.phone && !!errors.phone}
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          value={values.phone} />
                        <FormFeedback>{errors.phone}</FormFeedback>
                      </FormGroup>
                      <FormGroup >
                        <Label>Message<span className="text-danger"> *</span></Label>
                        <Input type="textarea"
                          name="message"
                          id="message"
                          placeholder=""
                          valid={!errors.message && values.message != ''}
                          invalid={touched.message && !!errors.message}
                          autoFocus={false}
                          onChange={handleChange}
                          required
                          rows={8}
                          value={values.message} />
                        <FormFeedback>{errors.message}</FormFeedback>
                      </FormGroup>
                      <FormGroup style={{ float: "right" }}>
                        <Button
                          style={{ width: 150 }}
                          type="submit" color="success" className="mr-1">Send</Button>
                      </FormGroup>
                    </Form>
                  )}
                </Formik>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default ScheduleDemo;



// WEBPACK FOOTER //
// ./client/src/views/ScheduleDemo/index.js